import { render, staticRenderFns } from "./announcement-msg.vue?vue&type=template&id=4342d977&scoped=true"
import script from "./announcement-msg.vue?vue&type=script&lang=js"
export * from "./announcement-msg.vue?vue&type=script&lang=js"
import style0 from "./announcement-msg.vue?vue&type=style&index=0&id=4342d977&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4342d977",
  null
  
)

export default component.exports